import { getIconBaseProps } from './utils';

export const singleLayout = {
  ...getIconBaseProps('singleLayout'),
  width: '20px',
  height: '20px',
  viewBox: '0 0 20 20',
  body: <rect width='20' height='20' rx='1' fill='#C3CBD1' />,
};
